<div>
    <section class="seatDetails"
    [ngClass]="{'rightToolTip': teamPopUpDirection, 'leftToolTip': !teamPopUpDirection}"
        [ngStyle]="{'position': 'fixed', 'left': xPos+'px', 'top': yPos+'px', 'transition': 'all 1s'}">
        <div  class="close" *ngIf="!teamPopUpDirection">
            <img src="assets/tooltip-close.svg" (click)="close($event)" alt="close">
        </div>
        <div class="user">
            <div>
                <p> {{teamDisplayText}}</p>
            </div>
            
        </div>
        <div  class="close" *ngIf="teamPopUpDirection">
        <img src="assets/tooltip-close.svg" (click)="close($event)" alt="close">
    </div>
    </section>
</div>